<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page

========================================================================================== -->


<template>
  <div class="h-screen flex w-full  vx-row no-gutter justify-center items-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/5 m-4">
      <vx-card no-shadow  v-if="!isLoading">

        <div class="vx-card__title mb-6">
        </div>

        <img src="" alt="coming-soon" class="mx-auto mb-16 mt-16" width="250">
        <div class="subscription">
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
  import VueCountdown from '@chenfengyuan/vue-countdown'
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import store from "../../store/store";
  const StaffRepository = RepositoryFactory.get('staff');
  const UserRepository = RepositoryFactory.get('user');

  export default {
    data () {
      return {
        value1: '',
        code: this.$route.params.code,
        userNotFound: false,
        isLoading: true,
        message: ''
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    async mounted() {
      // const is_logged = store.getters.currentUser
      await this.checkVerification();
    },
    components: {
      'countdown': VueCountdown
    },
    methods: {
      async checkVerification() {
        this.isLoading = true
        try {
          const data =  await UserRepository.accountVerify(this.code)
          this.userNotFound = false
          this.message = 'Your account Verified'
          this.isLoading = false
          this.$vs.loading.close()
          this.showSuccessMessage('Your account verified!')
          this.$router.push('/pages/login')
        } catch (e) {
          this.userNotFound = true
          this.message = e.response.data.message
          this.isLoading = false
          this.$vs.loading.close()
          this.showErrorMessage(this.message)
          this.$router.push('/pages/login')
          // this.convertAndNotifyError(e)
        }


      }
    }
  }

</script>

